import { Button, Modal } from 'react-bootstrap';
import { InvestmentModalProps, InvestmentProps } from './investment.types';
import InvestmentForm from './investment-form';
import { useEffect, useState } from 'react';
import api from '../../../services/api';

const CustomerInvestmentModal = ({
  onClose,
  onSuccess,
  isOpen,
  title,
  userId,
  investmentSelected,
}: InvestmentModalProps) => {
  const [formData, setFormData] = useState<InvestmentProps>({
    id: undefined,
    amount: 0,
    gat: 0,
    startDate: '',
    endDate: '',
    contract: { filename: '', file: null },
  });

  useEffect(() => {
    if (investmentSelected) {
      setFormData(investmentSelected);
    }
  }, [investmentSelected]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64String = (reader.result as string).split(',')[1];
        setFormData((prev) => ({
          ...prev,
          contract: {
            filename: file.name,
            file: base64String,
          },
        }));
      };
    }
  };

  const handleSubmit = async () => {
    try {
      let response;
      if (formData.id) {
        response = await api.patch(`/users/${userId}/investments/${formData.id}`, formData);
      } else {
        response = await api.post(`/users/${userId}/investments`, formData);
      }
      onSuccess(response.data);
    } catch (error: any) {
      console.error('Error al guardar la inversión:', error);
      
      // Extract specific error message from the API response
      let errorMessage = 'Ocurrió un error al guardar la inversión.';
      
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      alert(errorMessage);
    }
  };

  return (
    <Modal show={isOpen} onClose={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InvestmentForm
          investmentData={formData}
          handleChange={handleChange}
          handleFileChange={handleFileChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerInvestmentModal;
